export const GET_USERS_REQUEST = 'user/get_users_request'
export const SET_LOGGED = 'user/set_logged'
export const GET_USER = 'user/get_user'
export const GET_USERS = 'user/get_users'
export const ADD_USER = 'user/add_user'
export const DELETE_USER = 'user/delete_user'
export const EDIT_USER = 'user/edit_user'
export const USERS_FAIL = 'user/fail'
